import {
    asyncActionError,
    asyncActionStart,
    asyncActionFinish
} from "../async/asyncActions";
import { CREATE_TEST_TREE } from "./userTestTreeConstants";
import firebase from "../../config/firebase";

export const createTestTree = userId => async (dispatch, getState) => {
    const firestore = firebase.firestore();
    const activityRef = firestore
        .collection("users")
        .doc(userId)
        .collection("activity");

    // console.log("createTestTree() activity ref ", activityRef);
    try {
        dispatch(asyncActionStart());
        let testDocSnaps = await activityRef.get();
        console.log("createTestTree() testDocSnaps ", testDocSnaps);
        let testTree = {};

        // testTree[testDocSnaps.docs[i].data().testCollection];
        for (let i = 0; i < testDocSnaps.docs.length; i++) {
            if (
                !testTree.hasOwnProperty(
                    testDocSnaps.docs[i].data().testCollection
                )
            ) {
                // console.log("set array");
                testTree[testDocSnaps.docs[i].data().testCollection] = [];
                testTree[testDocSnaps.docs[i].data().testCollection].push(
                    testDocSnaps.docs[i].data().testId
                );
            } else {
                testTree[testDocSnaps.docs[i].data().testCollection].push(
                    testDocSnaps.docs[i].data().testId
                );
                // }
                //testAttended.push(testDocSnaps.docs[i].data());
                // testAttended.push(attendees);
            }
        }
        dispatch({ type: CREATE_TEST_TREE, payload: { testTree } });
        dispatch(asyncActionFinish());
    } catch (error) {
        dispatch(asyncActionError());
        console.log(error);
    }
};

// export const updateTestTree = ()

// export const getAttendedTest = userId => async dispatch => {
//     const firestore = firebase.firestore();
//     const activityRef = firestore
//         .collection("users")
//         .doc(userId)
//         .collection("activity");

//     try {
//         dispatch(asyncActionStart());
//         let testDocSnaps = await activityRef.get();
//         let testAttended = [];
//         for (let i = 0; i < testDocSnaps.docs.length; i++) {
//             testAttended.push(testDocSnaps.docs[i].data());
//             // testAttended.push(attendees);
//         }
//         dispatch({ type: TEST_ATTENDED, payload: { testAttended } });
//         dispatch(asyncActionFinish());
//     } catch (error) {
//         dispatch(asyncActionError());
//         console.log(error);
//     }
// };
